import React from 'react';

/**
 * BuilderDeviceContext — Iter 153.
 *
 * Provides the current preview device (desktop|tablet|mobile) to any
 * descendant component that needs to read it. Wired up at the top of
 * DashboardContent's canvas and consumed by WBImage so that each image
 * renders the right responsive frame.
 *
 * `setDevice` is the actual hook setter from useContentEditor — exposed
 * via the same context so the FloatingImageToolbar can flip device
 * without prop-drilling.
 */
export const BuilderDeviceContext = React.createContext({
  device: 'desktop',
  setDevice: () => {},
});

export const useBuilderDevice = () => React.useContext(BuilderDeviceContext);
